'use client';

import { useMemo, type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/providers/auth';
import { Icon } from '@/shared-ui/atoms/icon';
import { Link } from '@/shared-ui/atoms';
import { AccountIcon, HeartNoFillIcon } from '@/shared-ui/icons';

export const BurgerMenuTopStrip = (): ReactElement => {
    const { t } = useTranslation('header');
    const { t: tAccount } = useTranslation('account');
    const session = useAuth();
    const accountLink = useMemo(() => {
        const isAuthenticated = Boolean(session?.userType === 'registered' && session?.customerId);
        return isAuthenticated ? '/account/overview' : '/login';
    }, [session]);

    const accountLabel = useMemo(() => {
        const isAuthenticated = Boolean(session?.userType === 'registered' && session?.customerId);
        return isAuthenticated ? tAccount('myAccount') : t('signIn');
    }, [session, t, tAccount]);

    return (
        <div className="flex items-center justify-between bg-primary px-4 py-3 text-primary-foreground">
            <div className="flex items-center gap-4">
                <Link to={accountLink} aria-label={accountLabel} className="inline-flex">
                    <Icon icon={AccountIcon} className="size-6 text-primary-foreground" decorative />
                </Link>
                <Link to="/account/wishlist" aria-label={t('menu.savedItems', 'Saved Items')} className="inline-flex">
                    <Icon icon={HeartNoFillIcon} className="size-6 text-primary-foreground" decorative />
                </Link>
            </div>
        </div>
    );
};
